module.exports = __webpack_public_path__ + "static/img/img_copywriting.f4c0a246.png";